export class ScheduleBranchDays {
  constructor(
    public dayOfWeek?: number,
    public openingHour?: Date,
    public closingHour?: Date,
    public openingHourDelivery?: Date,
    public closingHourDelivery?: Date,
    public branchID?: number,
    public id?: number,
    public isNew?: boolean
  ) { }
}
